import { useState, useEffect } from "react";
import { Box, CheckBox, Image, Text } from "grommet";
import { updateStateHandler, DrawArrayByRows } from "../Utils/Utils";
import Cylindrical from '../../images/Berry Shapes/Cylindrical.png';
import Ellipsoid from '../../images/Berry Shapes/Ellipsoid.png';
import Obovoid from '../../images/Berry Shapes/Obovoid.png';
import Ovoid from '../../images/Berry Shapes/Ovoid.png';
import Round from '../../images/Berry Shapes/Round.png';

const BerryShapeChoice = (props) => {

    const choices = [
        {
            label: "Cylindrical",
            value: "Cylindrical",
            stateKey:'BerryShapeC',
            imageURL: Cylindrical,
            checked:props.preHarvestValues.BerryShapeC
        },
        {
            label: "Ellipsoid",
            value: "Ellipsoid",
            stateKey:'BerryShapeE',
            imageURL: Ellipsoid,
            checked:props.preHarvestValues.BerryShapeE
        },
        {
            label: "Obovoid",
            value: "Obovoid",
            stateKey:'BerryShapeO',
            imageURL: Obovoid,
            checked:props.preHarvestValues.BerryShapeO
        },
        // {
        //     label: "Ovoid",
        //     value: "Ovoid",
        //     stateKey:'BerryShapeOv',
        //     imageURL: Ovoid,
        //     checked:props.preHarvestValues.BerryShapeOv
        // },
        {
            label: "Round",
            value: "Round",
            stateKey:'BerryShapeR',
            imageURL: Round,
            checked:props.preHarvestValues.BerryShapeR
        },
    ];

    const [checked, setChecked] = useState([]);

    // Add/Remove checked item from list
    const handleCheck = (event, item) => {
        updateStateHandler(props.stateHandler, item.stateKey, event.target.checked );

        setPrevValue(checked.length);

        var updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
    };

    useEffect(() => {
        const newValue = checked.length;
        // console.log("newValue >> ", newValue);
        if(props.updateProgressByCheck){
            props.updateProgressByCheck(prevValue, newValue);
        }
    },[checked])
  
    const [prevValue, setPrevValue] = useState(0);

    useEffect(() => {
        // initialization previous value at page opening
        var updatedList = [...checked];      
        choices.map(option => {
            if(option.checked === true){
                updatedList = [...checked, option.value];
            }            
        })

        setChecked(updatedList);

        setPrevValue(updatedList.length);
        // console.log("prevValue >> ", updatedList.length);
    }, []);  
  
    const DrawItem = (item) =>
    {
        //console.log("item >> ",item);      
        return(
            <Box height="small" width="small" key={item.stateKey} pad="small" margin={{vertical: "xxsmall"}} align="start" justify="center" fill>          
                <Image  //fit="contain" 
                src={item.imageURL}></Image>
                <Box direction="row"  pad={{vertical: "5px"}} alignContent="start" align="start" width="120px" height="15px" style={{margin: "0 auto"}} >
                    <CheckBox value={item.value} 
                        disabled={props.disable}
                        checked={item.checked ? item.checked : false}             
                        onChange={ event => handleCheck(event, item)}
                        pad={{horizontal: "5px"}}
                        >
                    </CheckBox>

                    <Text alignSelf="start" size="small">
                    {item.label}
                    </Text> 
                </Box>          
            </Box>
        );
    };
        
    return (
        <Box direction="column" pad="xxsmall" align="center" 
            gap="small"  fill="horizontal">
            <Box alignSelf="start" pad={{horizontal: "small"}}>
                <Text alignSelf="start" color="brand" size="18px">
                Berry Shape:
                </Text>
            </Box> 
            {DrawArrayByRows(choices, props.numOfColumns, 'Berry', DrawItem)}
        </Box>
    );
};

export default BerryShapeChoice;
